import { Component, Inject, Injector } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs/internal/Subscription';
import { CompanyModel } from 'src/app/core/models/masters/company-master-model';
import { UserProfileModel } from 'src/app/services/models/userModel';
import { EWayService } from '../../e-way/e-way.service';
import { EWayBillPopupComponent } from '../../e-way/e-way-bill-popup/e-way-bill-popup.component';
import { BaseService } from 'src/app/infrastructure/infrastructure-services/services/base/base-service';
import { WrapperStandardRequest } from 'src/app/infrastructure/infrastructure-services/common/models/wrapper.model';
import { Router } from '@angular/router';
import { GlobalProperties } from 'src/app/global/global-properties';

@Component({
  selector: 'app-e-invoice-dropdown',
  templateUrl: './e-invoice-dropdown.component.html',
  styleUrls: ['./e-invoice-dropdown.component.css'],
  providers: [
    EWayBillPopupComponent,
    {
      provide: MatDialogRef, useValue: {}
    },
    {
      provide: MAT_DIALOG_DATA, useValue: {}
    }],
})
export class EInvoiceDropdownComponent {
  protected sessionService: any
  base64String: string = '';
  docEntry: string = '';
  objectType: string = '';
  screenType: number = 0;
  eWayBillNo: string = '';
  StockTransferEwayDocEntry: string = '';
  breadcrumbTitle: any;

  showPdf: boolean = false;
  irnFlag: boolean = false;
  reqData: WrapperStandardRequest<any> = new WrapperStandardRequest<{}>;
  // reqData: WrapperInputModel<EInvoiceBtnModel> = new WrapperInputModel<EInvoiceBtnModel>();
  eInvBtn: string = '';
  eInvArr = [
    { key: 'Generate IRN', value: 'GenerateIRN' },
    { key: 'Cancel IRN', value: 'CancelIRN' },
  ];
  subscriptionEInvoice!: Subscription;
  //ewayBill: any;
  isBoolGenerateewayBill: boolean = false;

  constructor(private dialog: MatDialog, private injector: Injector, private ewayService: EWayService,
    public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any,
    private ewayServiceBill: EWayService, private injectorBill: Injector, public dialogBill: MatDialog,
    private eWayBill: EWayBillPopupComponent, private snackbarService: BaseService<any>, private router: Router) {

    // this.ewayBill = new EWayBillComponent(dialogRef, data, ewayServiceBill, injectorBill, dialogBill, snackbarServiceBill);

    // this.sessionService = injector.get(SessionService);
    // this.logedInUserData = this.sessionService.getSessionData();
    // this.companyData = this.sessionService.getCurrentCompany();
    // this.reqData.data = new EInvoiceModel();
    // this.reqData.userGuid = this.logedInUserData.userGuid;
    // this.reqData.companyGuid = this.companyData.companyGuid;
    // this.reqData.customerGuid = this.companyData.customerGuid;
    // this.reqData.Version = 'V2';
  }
  ngOnInit(): void {
  }

  openEinvoiceDialog() {
    // let eInvoiceDialogRef = this.dialog.open(EInvoicePopupComponent, {
    //   data: {
    //   },
    //   panelClass: 'dynamictable'
    // });
    // eInvoiceDialogRef.afterClosed().subscribe((res: any) => {
    // });
  }

  // eInvoiceApi() {
  //   this.showPdf = false;
  //   this.reqData.data = new Object();
  //   this.reqData.userGuid = this.logedInUserData.userGuid;
  //   this.reqData.companyGuid = this.companyData.companyGuid;
  //   this.reqData.customerGuid = this.companyData.customerGuid;
  //   this.reqData.Version = 'V2';
  //   this.marketService.eInvoiceConnectrix(this.reqData).subscribe(res => {
  //     this.showPdf = true;
  //     this.base64String = 'data:application/pdf;base64,' + res?.fileBytes

  //   });
  // }

  getEwayBtnData(screen: string) {
    let value = screen.includes('AR Invoices') ? 'A/R Invoice(Item)' : 'A/R Credit Memo(Item)'
    // this.ewayService.getTransporters('UTL_ST_UDO_QRCF').subscribe(res => {
    //   res?.value[0]?.UTL_ST_RCF1Collection?.forEach((el: any) => {
    //     if (el.U_UTL_ST_LayName.includes(value)) {
    //       this.eInvArr.push({ key: el.U_UTL_ST_LayName, value: el.U_UTL_ST_LayName })
    //     }
    //   });
    // });
  }

  selectEInvoice(type: string, redirectTo="") {
    
   delete this.reqData.RequestData;
   (this.reqData as any).data = {
        "companyDB": GlobalProperties._companyDb,
        "password": "1234",
        "userName": "UTL2156",
        "dbInstance": "HANADB",
      //  "serviceLayerUrl": "https://fp2405.uneecopscloud.com:50000/b1s/v2/",
      "serviceLayerUrl": "https://fp2502:50000/b1s/v2/",
        "_DocEntry": (this.docEntry).toString(),
        "_ObjectType": this.objectType,
        "_DBConnection": "INT_WMSDEVSAPHANA_190",
        "databaseServerType": "HANA",
        "apiGateWayUrl": "string",
        "layoutName": "string",
        "layoutId": "string",
        "actionName": type,
        "documentCode": "string",
        "irn": "string",
        "returnDataQueryURL": "http://fs.uneecopscloud.com:8484/FetchData/V2",
        "u_UTL_ST_ESTATUS": "string",
        "u_UTL_ST_EWBSts": "string",
        "eWayBillNo": "string",
        "stockTransferEwayDocEntry": 0,
        "_StrSequence": "string"
    }

    // this.reqData.data.actionName = type;
    // this.reqData.data._DocEntry = (this.docEntry).toString();
    // this.reqData.data._ObjectType = this.objectType;
    this.ewayService.postEinvoiceData(this.reqData).subscribe(res => {
      const response = res.data;
      if (response) {
        switch (response.status) {
          case '0':
            this.snackbarService.showMessage(response?.errorDetail, 'X');
            if (this.screenType == 0) {
              this.router.navigate([redirectTo]);
            }
            break;
          case '1':
            const data = JSON.parse(response.data)[0];
            if (data.flag) {
              this.snackbarService.showMessage(`IRN ${type == 'GenerateIRN' ? 'Generated' : 'Cancelled'} Successfully`, 'X');
              if (this.breadcrumbTitle == 'Sales Invoice' && this.isBoolGenerateewayBill) {
                this.eWayBill.docEntry = this.docEntry;
                this.eWayBill.objectType = this.objectType;
                this.eWayBill.eWayBillNo = this.eWayBillNo;
                this.eWayBill.StockTransferEwayDocEntry = this.StockTransferEwayDocEntry;
                this.eWayBill.selectEWay('GenerateEwayBill', redirectTo);
              } else {
                if (this.screenType == 0) {
                  this.router.navigate([redirectTo]);
                }
              }
              this.ewayService.callEnvoice.next(true);
            } else {
              if (this.screenType == 0) {
                this.router.navigate([redirectTo]);
              }
              this.snackbarService.showMessage(`${data.message}`, 'X');
            }
            break;
        }
      }
    });
  }
}
